import wagonRoutes from './routes'

/* @ngInject */
const wagonRoute = (
  $stateProvider
) => {
  $stateProvider
    .state(wagonRoutes.index.path, {
      url: wagonRoutes.index.url,
      template: require('./templates/index.html'),
      controller: 'wagonCtrl',
      redirectTo: wagonRoutes.home.path,
    })
    .state(wagonRoutes.home.path, {
      url: wagonRoutes.home.url,
      template: require('./templates/home.html'),
    })
    .state(wagonRoutes.edit.path, {
      url: wagonRoutes.edit.url,
      template: require('./templates/edit.html'),
    })
    .state(wagonRoutes.details.path, {
      url: wagonRoutes.details.url,
      template: require('./templates/details.html'),
    })
}

export default wagonRoute



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/wagon/wagon.routes.js